// import { useLocation, Link } from "react-router";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import succes from "../../Assets/images/success.png";
import failed from "../../Assets/images/failed.png";
import "./MainBasket.scss";
import { SetSaleContext } from "../pages/Pages";

const PaymentResult = () => {
  //   const location = useLocation();
  const [result, setResult] = useState("");
  const [code, setCode] = useState("");
  const location = useLocation();
  const [resultText, setResultText] = useState("");
  const setSaleNum = useContext(SetSaleContext);

  useEffect(() => {
    if (location.search !== "") {
      setResult(location.search.split("=")[1].split("&")[0]);
      setCode(location.search.split("=")[2]);
    } else {
      setResult("1");
      setCode(location.state.factorId);
      const text =
        "با تشکر از حسن توجه شما،\nخرید شما با موفقیت انجام شد.\nسفارش شما از طریق پیک ارسال خواهد شد.";
      setResultText(text);
      localStorage.setItem("products", [])
    }
  }, []);
  useEffect(() => {
    if (result === 1) {
      localStorage.setItem("products", []);
      setSaleNum(0);
    }
  }, [result]);
  let textFoot = resultText && resultText.replace(/\n/g, "<br>");

  return (
    <>
      {result === "1" ? (
        <div className="payment-result">
          <div className="main-payment-result">
            <div className="success-img">
              <img src={succes} alt="" />
            </div>
            {resultText === "" ? (
              <h5>"پرداخت شما موفقیت آمیز بود"</h5>
            ) : (
              <h5 dangerouslySetInnerHTML={{ __html: textFoot }} />
            )}
            <div className="payment-code">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="17"
                viewBox="0 0 15 17"
                fill="none"
              >
                <path
                  d="M2 11.0981C1.70618e-06 9.94338 6.2632e-07 7.05663 2 5.90192L10.25 1.13879C12.25 -0.0159137 14.75 1.42746 14.75 3.73686L14.75 13.2631C14.75 15.5725 12.25 17.0159 10.25 15.8612L2 11.0981Z"
                  fill="#EE6900"
                />
              </svg>
              کد پیگیری
              <span>{code}</span>
            </div>
            <button className="back-to-page" onClick={() => localStorage.setItem("products" , "")}>
              <Link to="/">صفحه اصلی</Link>
            </button>
          </div>
        </div>
      ) : (
        <div className="payment-result">
          <div className="main-payment-result">
            <div className="success-img">
              <img src={failed} alt="" />
            </div>
            <h5>پرداخت ناموفق</h5>

            <button className="back-to-page">
              <Link to="/Basket"> سبد خرید </Link>
            </button>
          </div>
        </div>
      )}
    </>
  );
};
export default PaymentResult;
